module.exports = __webpack_public_path__ + "img/icon-tel.4dfe7f7.png";